import React from 'react';
import { trustInfo } from '../../data/mock';
import { Shield, Handshake, FileCheck, Eye } from 'lucide-react';

const TRUST_CARDS = [
  { icon: Shield, title: 'Honest Dealings', desc: 'Transparent offers with no hidden clauses', bg: 'bg-emerald-100', fg: 'text-emerald-600' },
  { icon: Handshake, title: 'Clear Communication', desc: 'Stay informed at every step of the process', bg: 'bg-amber-100', fg: 'text-amber-600' },
  { icon: FileCheck, title: 'Simple Contracts', desc: 'Straightforward paperwork, no legal jargon', bg: 'bg-blue-100', fg: 'text-blue-600' },
  { icon: Eye, title: 'Full Transparency', desc: 'Direct purchase or assignment - we explain all options', bg: 'bg-slate-200', fg: 'text-slate-600' },
];

const TrustCopy = () => (
  <div>
    <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-700 rounded-full text-sm font-semibold mb-4">
      Our Promise
    </span>
    <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
      {trustInfo.title}
    </h2>
    {trustInfo.paragraphs.map((para) => (
      <p key={para} className="text-lg text-slate-600 mb-4 leading-relaxed">
        {para}
      </p>
    ))}
  </div>
);

const TrustCard = ({ icon: Icon, title, desc, bg, fg }) => (
  <div className="p-6 bg-slate-50 rounded-2xl hover:shadow-lg transition-shadow duration-300">
    <div className={`w-12 h-12 rounded-xl ${bg} flex items-center justify-center mb-4`}>
      <Icon className={`w-6 h-6 ${fg}`} />
    </div>
    <h3 className="font-semibold text-slate-900 mb-2">{title}</h3>
    <p className="text-sm text-slate-600">{desc}</p>
  </div>
);

const TrustGrid = () => (
  <div className="grid grid-cols-2 gap-4">
    {TRUST_CARDS.map((c) => <TrustCard key={c.title} {...c} />)}
  </div>
);

const TrustSection = () => (
  <section className="py-20 bg-white">
    <div className="container mx-auto px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <TrustCopy />
          <TrustGrid />
        </div>
      </div>
    </div>
  </section>
);

export default TrustSection;
